<template>
  <a :href="props.item.link">
    <div
      class="menu-item p-1.5 md:p-3 px-4 md:px-3 text-base font-semibold rounded-lg hover:bg-gray-50 cursor-pointer text-gray-900"
      style="width: inherit !important;"
    >
      <p v-html="replaceWithBr(props.item.label)"></p>
    </div>
  </a>
</template>

<script setup>
import { useHeaderStore } from '@/stores'

const headerStore = useHeaderStore()

const props = defineProps(['item'])

function replaceWithBr(text) {
  return text.replace(/\n/g, "<br />")
}

</script>